import { httpClient } from '@/utils/http'
import type { BaseResponse, RoleList } from '@/types/api'

export class HomeAPI {
  static async getRoleList(data: any): Promise<BaseResponse<RoleList>> {
    return httpClient.post<RoleList>('/getRoleList', data)
  }
  /**
   * 获取推荐角色列表
   */
  static async getRecommendRoles(data: any): Promise<BaseResponse<any>> {
    return httpClient.post<any>('/getRecommendRoles', data)
  }
  /**
   * 获取对话列表
   */
  static async getDialogueList(data: any): Promise<BaseResponse<any>> {
    return httpClient.post<any>('/getDialogueList', data)
  }
  /**
   * 删除用户
   */
  static async deleteUser(data: any): Promise<BaseResponse<any>> {
    const response = await httpClient.post<any>('/deleteUser', data, {
      showLoading: true
    })
    return response
  }
  /**
   * 角色分类列表
  */
  static async getRoleTypeList(data: any): Promise<BaseResponse<any>> {
    const response = await httpClient.post<any>('/roleTypeList', data, {
      showLoading: true
    })
    return response
  }
  /**
   * svip套餐
  */
  static async getSubscribePackages(data: any): Promise<BaseResponse<any>> {
    return httpClient.post<any>('/getSubscribePackages', data)
  }
  /**
   * 获取筛选列表
  */
  static async getRoleTagsList(data: any): Promise<BaseResponse<any>> {
    return httpClient.post<any>('/getRoleTags', data)
  }
}

// 默认导出
export default {
  HomeAPI
}
